import { adminHttpClient } from '../../../commons/adminHttpClient'
import { BaseProductClassValues } from './productClass/baseProductClass'
export interface WaitingPeriodValues extends BaseProductClassValues {
  waitingPeriod: number
}

const updateWaitingPeriod = (values: WaitingPeriodValues): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/ClassDesign/WaitingPeriod', values)
}

export default updateWaitingPeriod
